// Contact page: shows the order number field only for the order subject, marks the contact options as
// reachable during working hours (Dutch time), and moves focus to the confirmation after sending.
// A ?bericht= link (from the supplement test) fills in an empty message.
if (!customElements.get('movitamins-contact-page')) {
  customElements.define(
    'movitamins-contact-page',
    class MovitaminsContactPage extends HTMLElement {
      connectedCallback() {
        this.initOrderField();
        this.updateHours();
        this.prefillMessage();

        const success = this.querySelector('[data-mvcp-success]');
        if (success) {
          success.focus({ preventScroll: true });
          success.scrollIntoView({ block: 'center' });
        }
      }

      initOrderField() {
        const subject = this.querySelector('[data-mvcp-subject]');
        const order = this.querySelector('[data-mvcp-order]');
        if (!subject || !order) return;
        const input = order.querySelector('input');
        const toggle = () => {
          // Keep the field visible when it already has a value, so nothing typed gets hidden.
          order.hidden = subject.value !== subject.dataset.orderSubject && input.value === '';
        };
        subject.addEventListener('change', toggle);
        toggle();
      }

      prefillMessage() {
        const message = this.querySelector('[data-mvcp-message]');
        const text = new URLSearchParams(window.location.search).get('bericht');
        if (!message || !text || message.value.trim()) return;
        message.value = text.slice(0, 2000);
      }

      updateHours() {
        const hours = this.querySelector('[data-mvcp-hours]');
        if (!hours) return;
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Amsterdam',
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
          })
            .formatToParts(new Date())
            .map((part) => [part.type, part.value])
        );
        const minutes = (time) => {
          const [hour, minute] = String(time).split(':').map(Number);
          return hour * 60 + (minute || 0);
        };
        const now = Number(parts.hour) * 60 + Number(parts.minute);
        const weekday = !['Sat', 'Sun'].includes(parts.weekday);
        const open = weekday && now >= minutes(hours.dataset.open) && now < minutes(hours.dataset.close);
        hours.classList.toggle('is-open', open);
        const label = hours.querySelector('[data-mvcp-now]');
        if (label) label.hidden = !open;
      }
    }
  );
}
